var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed"},[_c('b-navbar',{staticClass:"bg-company-red",attrs:{"position:sticky":"","variant":"faded","toggleable":"lg","type":"dark"}},[_c('b-container',[_c('b-navbar-brand',[_vm._v("Un Ray")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1569ddf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbarAfilia.vue
// module id = null
// module chunks = 